import React, { useEffect,useState,useMemo  } from "react";
import { useSelector, useDispatch } from "react-redux";
import {  fetchShipmentsByEmail,updatePinnedShipments } from "../../store/features/shipmentsSlice"; // Adjust path as needed
import CaseBox from "./CaseBox";
import Filters from "../Filters/Filters";
import SearchBar from "../Searchbar/SearchBar";

const ClosedList = () => {
  const dispatch = useDispatch();
  const email = "supplychain@linear-works.com";
    const { shipments, status } = useSelector((state) => state.shipments);
    const [filter, setFilter] = useState("Attention"); // Left filter buttons
    const [searchQuery, setSearchQuery] = useState(""); // Search bar query
    const [advancedFilters, setAdvancedFilters] = useState({}); // Advanced filter values
    const [sortOrder, setSortOrder] = useState("asc"); // Sorting order state
  
    // Fetch shipments on component mount
    // useEffect(() => {
    //   if (status === "idle") {
    //     dispatch(fetchShipments());
    //   }
    // }, [dispatch, status]);
    useEffect(() => {
      dispatch(fetchShipmentsByEmail(email));
    }, [dispatch, email]);
  
    // Handle pin toggle with persistence
    const handleToggleTag = (caseNumber, isCurrentlyTagged) => {
      dispatch(updatePinnedShipments({ caseNumber, isTagged: !isCurrentlyTagged })); // Persist the new tag state
    };
  
    const parseCustomDate = (dateString) => {
      const [day, month, year] = dateString.split("-").map(Number); // Split and convert to numbers
      return new Date(year, month - 1, day); // Create a Date object (months are 0-based in JavaScript)
    };
  
    const sortByDate = (cases, sortOrder) => {
      return [...cases].sort((a, b) => {
        // Place cases with `issue === true` at the front
        if (a.issue && !b.issue) return -1; // `a` should come before `b`
        if (!a.issue && b.issue) return 1;  // `b` should come before `a`
    
        // Retrieve the earliest timestamp from the emailBodies list for each case
        const getEarliestTimestamp = (emailBodies) => {
          if (!emailBodies || emailBodies.length === 0) return Infinity; // Fallback for cases with no emailBodies
          return Math.min(...emailBodies.map(email => new Date(email.timestamp).getTime()));
        };
    
        const earliestA = getEarliestTimestamp(a.emailBodies);
        const earliestB = getEarliestTimestamp(b.emailBodies);
    
        // Sort by the earliest timestamp
        return sortOrder === "asc"
          ? earliestA - earliestB
          : earliestB - earliestA;
      });
    };
  
    // Handle advanced filters
    const handleApplyAdvancedFilters = (filters) => {
      setAdvancedFilters(filters); // Save advanced filter options
    };
  
    const handleRemoveFilters = () => {
      setAdvancedFilters({}); // Clear all advanced filter values
    };
  
    // Helper function to check if a participant list contains a specific email
    const hasEmail = (participants, targetEmail) => {
      return participants.some(participant => {
        const entries = participant.split(',').map(entry => entry.trim());
        return entries.some(entry => {
          const emailMatch = entry.match(/<([^>]+)>/); // Extract email from "Name <email>"
          const email = emailMatch ? emailMatch[1] : entry; // Use extracted email or the entire entry
          return email.toLowerCase() === targetEmail.toLowerCase();
        });
      });
    };
  
    // Filter Logic
    const filteredCases = useMemo(() => {
      return sortByDate(
        shipments
          .filter((c) => c.current_status === "closed")
          .filter((c) => {
            if (filter === "All") return true;
            if (filter === "PendingReply") return c.status === "pending";
            if (filter === "Attention") return c.issue === true;
            if (filter === "Completed") return c.status === "completed";
            return true;
          })
          .filter((c) => {
            const { threadId, senderEmail, subject, emailAddress } = advancedFilters;
            return (
              (!threadId || c.case_number.toLowerCase().includes(threadId.toLowerCase())) &&
              (!senderEmail || hasEmail(c.participants, senderEmail)) &&
              (!subject || c.subject.toLowerCase().includes(subject.toLowerCase())) &&
              (!emailAddress || hasEmail(c.participants, emailAddress))
            );
          })
          .filter((c) => {
            if (!searchQuery) return true;
            const lowerQuery = searchQuery.toLowerCase();
            return (
              c.shipment_id.toLowerCase().includes(lowerQuery) ||
              c.subject.toLowerCase().includes(lowerQuery) ||
              c.status.toLowerCase().includes(lowerQuery)
            );
          }),
        sortOrder
      );
    }, [shipments, filter, advancedFilters, searchQuery, sortOrder]);
    
    const toggleSortOrder = () => {
      setSortOrder((prevSortOrder) => (prevSortOrder === "asc" ? "desc" : "asc"));
    };
    
  
    // Divide into pinned and unpinned cases
    const pinnedCases = filteredCases.filter((c) => c.pinned);
    const unpinnedCases = filteredCases.filter((c) => !c.pinned);
  
    if (status === "loading") return <div>Loading...</div>;
    if (status === "failed") return <div>Failed to load cases.</div>;  

  return (
    <div className="flex flex-col h-screen">
      <div className="flex items-center justify-between mb-6">
        {/* Left Filter Buttons */}
        {/* Search and Advanced Filters */}
        <div className="pr-4">
          <Filters
            onRemoveFilters={handleRemoveFilters}
            onApplyAdvancedFilters={handleApplyAdvancedFilters}
          />
        </div>
        
      </div>
      <div className="flex items-center justify-between p-1 rounded">
        <h2 className="text-2xl font-bold text-font-LIGHT">
            Cases that have been manually closed
        </h2>

        {/* Sort by Date Button */}
        <button
          className="px-4 py-2 rounded text-black hover:underline"
          onClick={() => setSortOrder(sortOrder === "asc" ? "desc" : "asc")}
        >
          Sort by date {sortOrder === "asc" ? "↑" : "↓"}
        </button>
      </div>
      <div className="flex-1 py-2 overflow-y-auto h-screen">
        {pinnedCases.length > 0 && (
          <div className = "m">
            {pinnedCases.map((caseData) => (
              <CaseBox
                key={caseData.thread_id}
                caseData={caseData}
                onToggleTag={handleToggleTag}
              />
            ))}
          </div>
        )}

        {/* Divider */}
        {pinnedCases.length > 0 && unpinnedCases.length > 0 && (
          <hr className="my-4 border-t border-gray-300" />
        )}

        {/* Render Unpinned Cases */}
        {unpinnedCases.length > 0 && (
          <div className="mb-2">
            {unpinnedCases.map((caseData) => (
              <CaseBox
                key={caseData.thread_id}
                caseData={caseData}
                onToggleTag={handleToggleTag}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ClosedList;